var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"dealer-information"},[_c('summary-card',{attrs:{"disabled":_vm.disabled,"summaryInformation":_vm.dealerInformation,"status":_vm.status}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }